import Styled from "styled-components";

export type LayoutType = "image-left" | "image-right" | "image-below";

export interface ContentProps {
  $layoutType?: LayoutType;
}

export interface IllustrationProps {
  $layoutType?: LayoutType;
}

export interface MessageProps {
  $layoutType?: LayoutType;
}

export interface HeadlineProps {
  $layoutType?: LayoutType;
}

export interface PitchProps {
  $layoutType?: LayoutType;
}

export const Container = Styled.div`
  padding: 2rem 0;

  ${(props) => props.theme.breakpoints.up("medium")} {
    padding: 4.6875rem 0;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    padding: 5.625rem 0;
  }
`;

export const Content = Styled.div<ContentProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  margin: 0 auto;

  ${(props) =>
    props.$layoutType === "image-below" &&
    `
      align-items: center;
  `};

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 3rem);
    flex-direction: row-reverse;
    justify-content: space-between;
    gap: 1.5rem;
    
    ${(props) =>
      props.$layoutType === "image-right" &&
      `
      flex-direction: row;
    `};

    ${(props) =>
      props.$layoutType === "image-below" &&
      `
      flex-direction: column;
    `};
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: calc(100% - 10rem);
    gap: 7.5rem;

    ${(props) =>
      props.$layoutType === "image-below" &&
      `
      gap: 9.375rem;
    `};
  }
`;

export const Illustration = Styled.div<IllustrationProps>`
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  max-height: 35rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    flex: 0.55;

    ${(props) =>
      props.$layoutType === "image-below" &&
      `
      max-height: 100%;
      max-width: 100%;
      box-shadow: rgba(3, 3, 3, 0.1) 0px 2px 20px;
      margin-top: 5rem;
    `};
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    ${(props) =>
      props.$layoutType === "image-below" &&
      `
      margin-top: 0;
    `};
  }
`;

export const Message = Styled.div<MessageProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.875rem;
    
  ${(props) => props.theme.breakpoints.up("medium")} {
    flex: 0.5;
    justify-content: center;
    align-items: flex-start;

    ${(props) =>
      props.$layoutType === "image-below" &&
      `
      align-items: center;
    `};
  }

  ${(props) => props.theme.breakpoints.up("medium")} {
    font-size: 1.25rem;
    flex: 0.45;
  }
`;

export const Tagline = Styled.span`
  color: #7F7F7F;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    font-size: 1.25rem;
  }
`;

export const Pitch = Styled.div<PitchProps>`
  font-size: 1.25rem;
  line-height: 1.25;
  font-weight: 400;
  letter-spacing: -0.2px;

  ${(props) =>
    props.$layoutType === "image-below" &&
    `
    text-align: center;
  `};

  ${(props) => props.theme.breakpoints.up("large")} {
    font-size: 1.625rem;
  }

  & > p {
    margin: 1rem 0;
  }

  & > p:first-child {
    margin-top: 0;
  }

  & > p:last-child {
    margin-bottom: 0;
  }
`;

export const Link = Styled.a`
  text-decoration: none;
`;
